<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query.storageRoom.name" placeholder="business.label.storageRoomName" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query.no" placeholder="business.label.no" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query.name" placeholder="business.label.name" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-select v-model="query.zoneType" :options="zoneTypes" placeholder="business.label.zoneType" @change="refresh"/>
        <vxe-select v-model="query.workstation" :options="workstations" placeholder="business.label.workstation" @change="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.add" icon="vxe-icon-add" status="primary" @click="add"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="no" title="business.label.zoneNo" width="100"/>
        <vxe-column field="name" title="business.label.zoneName" width="120"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="available" title="business.label.available" width="70"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:zoneTypes}" field="zoneType" title="business.label.zoneType" width="100"/>
        <vxe-column field="storageRoom.name" title="business.label.storageRoomName" width="150"/>
        <vxe-column field="floor" title="business.label.floor" width="60"/>
        <vxe-column field="region.name" title="business.label.bigRegion" width="100"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:putawayModes}" field="putawayMode" title="business.label.putawayMode" width="100"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:transmissionTypes}" field="transmissionType" title="business.label.transmissionType" width="100"/>
        <vxe-column field="stagingType.name" title="business.label.stagingType" width="100"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="device" title="business.label.device" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="workstation" title="business.label.workstation" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="singleWork" title="business.label.singleWork" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="transfer" title="转运" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="sendable" title="发送" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="allocable" title="分配" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="relay" title="接力拣选" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoObtain" title="business.label.autoObtain" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoConfirm" title="business.label.autoConfirm" width="70"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row)"/>
            <vxe-button v-if="!row.available" content="button.enable" icon="vxe-icon-unlock" status="success" @click.stop="enable(row,true)"/>
            <vxe-button v-if="row.available" :disabled="row.locationStatus>1" content="button.disable" icon="vxe-icon-lock" status="danger" @click.stop="enable(row,false)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import { Zone } from '@/api/dto/common/Zone'

export default {
  name: 'ZoneTable',
  data() {
    return {
      loading: false,
      query: new Zone(),
      data: [],
      page: 1,
      size: 20,
      contentSize: 0,
      workstations: [
        { label: this.$t('business.label.true'), value: true },
        { label: this.$t('business.label.false'), value: false }
      ]
    }
  },
  activated() {
    this.refresh()
  },
  props: {
    zoneTypes: {
      type: Array,
      default: []
    },
    putawayModes: {
      type: Array,
      default: []
    },
    transmissionTypes: {
      type: Array,
      default: []
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      const args = {
        ...this.query.toJSONObject(),
        'storageRoom.name': this.query.storageRoom.name
      }
      findAll('zoneFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = new Zone()
      this.refresh()
    },
    add() {
      this.$emit('add')
    },
    edit(row) {
      this.$emit('edit', row)
    },
    enable(row, available) {
      this.$emit('enable', row, available)
    }
  }
}
</script>